export default {
    /**
     * 0: 非终生套餐
     */
    FALSE: 0,
    /**
     * 1: 2年期假终生套餐
     */
    FAKE: 1,
    /**
     * 2: 100年期终生套餐 一次购买或分期付款完成
     */
    TRUE: 2,
    /**
     * 3: 分期付款中
     */
    TRUE_CIRCLING: 3,
    /**
     * 4: 分期付款取消
     */
    TRUE_CIRCLING_CANCEL: 4
};